import React from 'react';
import { FaArrowRight, FaEnvelope, FaGithub, FaMapMarkerAlt } from 'react-icons/fa';
import HeroThreeScene from './HeroThreeScene';

function Hero({ profile, metrics }) {
  return (
    <section className="portfolioHero sectionReveal" id="home">
      <div className="portfolioHero__glow" aria-hidden="true" />
      <div className="portfolioHero__content">
        <span className="portfolioEyebrow">Backend, cloud, and product engineering</span>
        <h1>Build systems that survive launch.</h1>
        <p className="portfolioHero__intro">
          I build backend-heavy products with clean APIs, practical interfaces, and deployment-ready cloud infrastructure.
        </p>

        <div className="portfolioHero__cta">
          <a href="#contact" className="portfolioButton portfolioButton--primary">
            Start
            <FaArrowRight />
          </a>
          <a href="#projects" className="portfolioButton">
            Work
          </a>
        </div>
      </div>

      <div className="portfolioHero__visual">
        <article className="portfolioProfileCard" aria-label={`${profile.name} profile card`}>
          <img src={profile.image} alt={profile.name} />
          <div className="portfolioProfileCard__body">
            <div>
              <h2>{profile.name}</h2>
              <p>{profile.role}</p>
            </div>
            <span className="portfolioProfileCard__availability">Available for backend and cloud roles</span>
            <div className="portfolioProfileCard__meta">
              <span><FaMapMarkerAlt /> {profile.location}</span>
              <span>{profile.company}</span>
            </div>
            <div className="portfolioProfileCard__actions">
              <a href={`mailto:${profile.email}`}><FaEnvelope /> Email</a>
              <a href={profile.github} target="_blank" rel="noreferrer"><FaGithub /> GitHub</a>
            </div>
          </div>
        </article>
        <HeroThreeScene />
      </div>

      <div className="portfolioMetrics" aria-label="Credibility metrics">
        {metrics.map((metric) => (
          <article key={metric.label}>
            <strong>{metric.value}</strong>
            <span>{metric.label}</span>
            <p>{metric.detail}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Hero;
